<template>
  <div>
    <va-card>
      <template slot="header">
        <div class="va-card__header-title" color="secondary">
          <router-link to="/">{{ $t('menu.dashboard') }}</router-link> / {{ $t('menu.vehicleExtras') }}
        </div>
        <div class="va-card__header-actions"></div>
      </template>

      <va-data-table
        :fields="fields"
        :data="items"
        :loading="loading"
        api-mode
      >
        <template slot="actions" slot-scope="props">
          <va-popover :message="`${$t('tables.actions.translate')} ` + (props.rowData.name.en ? `${$t('tables.actions.edit')}` : `${$t('tables.actions.add')}`)" placement="bottom" color="dark" :disabled="isMobile">
            <va-button flat small :color="props.rowData.name.en ? 'info' : 'gray'" class="ma-0" @click.stop="buttonAsHref('/ekstra/'+props.rowData.id+'/ceviri')">
              {{ $t('tables.actions.english') }}
            </va-button>
          </va-popover>
          <va-popover :message="`${$t('tables.actions.edit')}`" placement="bottom" color="dark" :disabled="isMobile">
            <va-button flat small color="info" icon="fa fa-pencil" @click.stop="buttonAsHref('/ekstra/'+props.rowData.id+'/duzenleme')"/>
          </va-popover>
        </template>
      </va-data-table>
    </va-card>
  </div>
</template>

<script>
import vehicleExtraServices from '../../../services/api/vehicleExtra'
import responseMixin from '../../../services/api/response'
import helperMixin from '../../../services/helper'
export default {
  mixins: [responseMixin, helperMixin],
  data () {
    return {
      isMobile: false,
      loading: false,
      items: [],
    }
  },
  computed: {
    fields () {
      return [{
        name: 'name_readable',
        title: this.$t('tables.headings.extra.name'),
        width: '30%',
      }, {
        name: '__slot:actions',
        dataClass: 'text-right',
      }]
    }
  },
  methods: {
    async getVehicleExtras(page=1, filter = {}){
      this.loading = true;

      filter.page = page;
      filter.limit = 100;

      const result = await vehicleExtraServices.get('', {
          params: filter
        });
      if(result.error){
        this.items = [];
        return ;
      }
      this.loading = false;
      this.items = result.data.data;
    },
  },
  created() {
    this.isMobile = this.checkIsMobile();
    this.getVehicleExtras()
  }
}
</script>
